import { render, staticRenderFns } from "./flexPetz.vue?vue&type=template&id=86bcf4c6&scoped=true"
import script from "./flexPetz.vue?vue&type=script&lang=js"
export * from "./flexPetz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86bcf4c6",
  null
  
)

export default component.exports